import React, { useContext } from 'react';

import './product-list-template-style.scss';

import useScroll from '@src/hooks/useScroll';
import { DeviceContext, deviceType } from '@providers';

import TopButton from '@src/componentsNew/Buttons/TopButton/TopButton';
import MobileProductListTopSection from '@src/componentsNew/ProductListTemplate/ProductListTopSection/MobileProductListTopSection';
import MobileProductListSection from '@src/componentsNew/ProductListTemplate/ProductListSection/MobileProductListSection';
import DesktopProductList from '@src/componentsNew/ProductListTemplate/ProductListTopSection/DesktopProductList';

import { ProductListBaseProps } from '@src/componentsNew/ProductListTemplate/type';

export const ProductListTemplate = ({
  pageTitle,
  images,
  brandInfo,
  level0SubMenu,
  level1SubMenu,
  showLevel1SubmenuAllButton,
  selectedLevel0SubMenu,
  selectedLevel1SubMenu,
  handleClickLevel0SubMenu,
  handleClickLevel1SubMenu,
  productTotalCount,
  setProductTotalCount,
  variables,
  setVariables,
}: ProductListBaseProps) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);
  const { isScrolled, scrollTop } = useScroll();

  return (
    <div id={`${isMobile ? 'mobile' : 'desktop'}-product-list-template-wrapper`}>
      {isMobile ? (
        <>
          <MobileProductListTopSection
            pageTitle={pageTitle}
            images={images}
            brandInfo={brandInfo}
            level0SubMenu={level0SubMenu}
            level1SubMenu={level1SubMenu}
            showLevel1SubmenuAllButton={showLevel1SubmenuAllButton}
            selectedLevel0SubMenu={selectedLevel0SubMenu}
            selectedLevel1SubMenu={selectedLevel1SubMenu}
            handleClickLevel0SubMenu={handleClickLevel0SubMenu}
            handleClickLevel1SubMenu={handleClickLevel1SubMenu}
            productTotalCount={productTotalCount}
            variables={variables}
            setVariables={setVariables}
          />

          <MobileProductListSection variables={variables} setProductTotalCount={setProductTotalCount} />
        </>
      ) : (
        <DesktopProductList
          pageTitle={pageTitle}
          images={images}
          level0SubMenu={level0SubMenu}
          level1SubMenu={level1SubMenu}
          showLevel1SubmenuAllButton={showLevel1SubmenuAllButton}
          selectedLevel0SubMenu={selectedLevel0SubMenu}
          selectedLevel1SubMenu={selectedLevel1SubMenu}
          handleClickLevel0SubMenu={handleClickLevel0SubMenu}
          handleClickLevel1SubMenu={handleClickLevel1SubMenu}
          productTotalCount={productTotalCount}
          variables={variables}
          setVariables={setVariables}
          setProductTotalCount={setProductTotalCount}
        />
      )}

      {isScrolled && <TopButton isMobile={isMobile} onClick={scrollTop} />}
    </div>
  );
};

export default ProductListTemplate;
